export default "__VITE_ASSET__DUTBy_3y__"